export default __webpack_public_path__ + "static/media/logout-modal-icon.b8c60b0f.svg";